"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_1 = require("react-redux");
var victory_1 = require("victory");
var hudled_graph_1 = __importDefault(require("components/Graphs/Theme/hudled-graph"));
var processExpenditures_1 = require("utils/processExpenditures");
var single_1 = require("utils/selectors/single");
var today = new Date();
var thisMonth = today.getMonth();
var thisYear = today.getFullYear();
var monthsThisYear = __spreadArray([], __read(Array(thisMonth).keys()), false).map(function (x) { return x + 1; });
var monthsLastYear = __spreadArray([], __read(Array(12 - thisMonth).keys()), false).map(function (x) { return x + 1 + thisMonth; });
var monthsToDisplay = (_a = {},
    _a[thisYear - 1] = monthsLastYear,
    _a[thisYear] = monthsThisYear,
    _a);
var monthLabels = {
    1: 'jan',
    2: 'feb ',
    3: 'mar',
    4: 'apr',
    5: 'may',
    6: 'jun',
    7: 'jul',
    8: 'aug ',
    9: 'sep ',
    10: 'oct ',
    11: 'nov',
    12: 'dec ',
};
var monthLabelsToDisplay = __assign((_b = {}, _b[thisMonth + 1] = "".concat(monthLabels[thisMonth + 1], " \n ").concat(thisYear - 1), _b), (thisMonth !== 0
    ? (_c = {
            1: thisYear
        },
        _c[thisMonth] = "".concat(monthLabels[thisMonth], " \n ").concat(thisYear),
        _c) : { 12: thisYear }));
var lineColours = [
    '#EE8EE2',
    '#FF756D',
    '#FFDF00',
    '#85DE77',
    '#779ECB',
    '#B29DD9',
    '#DA9100',
    '#FF945E',
    '#3E87C6',
    '#F10C33',
];
var SpendTrendGraph = function (_a) {
    var e_1, _b, e_2, _c;
    var serviceStats = _a.serviceStats, chartType = _a.chartType;
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var currency = myCompany === null || myCompany === void 0 ? void 0 : myCompany.baseCurrency;
    var serviceStatChartData = serviceStats === null || serviceStats === void 0 ? void 0 : serviceStats.reduce(function (acc, serviceStat) {
        var e_3, _a, e_4, _b, _c;
        var _d;
        var expenditures = serviceStat.expenditures;
        if (!expenditures) {
            return acc;
        }
        var key = 'All';
        var monthlySpendData = __assign({}, acc[key]);
        try {
            for (var _e = __values(Object.keys(monthsToDisplay)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var year = _f.value;
                try {
                    for (var _g = (e_4 = void 0, __values(monthsToDisplay[year])), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var month = _h.value;
                        var monthYear = "".concat(month, "-").concat(year);
                        monthlySpendData[monthYear] = (monthlySpendData[monthYear] || 0)
                            + ((0, processExpenditures_1.aggregateMonthlyTransactions)((_d = expenditures === null || expenditures === void 0 ? void 0 : expenditures[year]) === null || _d === void 0 ? void 0 : _d[month]) || 0);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return __assign(__assign({}, acc), (_c = {}, _c[key] = monthlySpendData, _c));
    }, {});
    var categories = Object.keys(serviceStatChartData);
    var prefix = (0, end2end_1.getCurrencySymbol)(currency);
    var showChartData;
    if (categories.length) {
        if (chartType === 'STACK') {
            showChartData = ((0, jsx_runtime_1.jsx)(victory_1.VictoryStack, { children: categories.map(function (category, idx) { return ((0, jsx_runtime_1.jsx)(victory_1.VictoryLine, { data: Object.keys(serviceStatChartData[category]).map(function (monthYear) { return ({
                        monthYear: monthYear,
                        spendMonth: serviceStatChartData[category][monthYear],
                    }); }), x: "monthYear", y: "spendMonth", style: {
                        data: {
                            stroke: lineColours[idx % lineColours.length],
                            strokeWidth: 2,
                        },
                    } }, category)); }) }));
        }
        else {
            showChartData = (categories.map(function (category) {
                var lineData = Object.keys(serviceStatChartData[category]).map(function (monthYear) { return ({
                    monthYear: monthYear,
                    spendMonth: serviceStatChartData[category][monthYear],
                }); });
                return ((0, jsx_runtime_1.jsx)(victory_1.VictoryLine, { interpolation: "bundle", data: lineData, x: "monthYear", y: "spendMonth", style: {
                        data: {
                            stroke: '#FF9FBF',
                            strokeWidth: 3,
                        },
                    } }, category));
            }));
        }
    }
    else {
        var emptyDataLine = [];
        try {
            for (var _d = __values(Object.keys(monthsToDisplay)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var year = _e.value;
                try {
                    for (var _f = (e_2 = void 0, __values(monthsToDisplay[year])), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var month = _g.value;
                        var monthYear = "".concat(month, "-").concat(year);
                        var spendMonth = 0;
                        emptyDataLine.push({ monthYear: monthYear, spendMonth: spendMonth });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        showChartData = ((0, jsx_runtime_1.jsx)(victory_1.VictoryLine, { interpolation: "bundle", data: emptyDataLine, x: "monthYear", y: "spendMonth", style: {
                data: {
                    stroke: '#FF9FBF',
                    strokeWidth: 3,
                },
            } }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(victory_1.VictoryChart, __assign({ theme: hudled_graph_1.default, height: 450, width: 900, domainPadding: 4 }, { children: [(0, jsx_runtime_1.jsx)(victory_1.VictoryAxis, { tickValues: Object.keys(monthsToDisplay).reduce(function (acc, year) { return (__spreadArray(__spreadArray([], __read(acc), false), __read(monthsToDisplay[year].map(function (month) { return "".concat(month, "-").concat(year); })), false)); }, []), tickFormat: Object.keys(monthsToDisplay).reduce(function (acc, year) { return (__spreadArray(__spreadArray([], __read(acc), false), __read(monthsToDisplay[year].map(function (month) { return monthLabelsToDisplay[month]; })), false)); }, []), style: {
                        ticks: { stroke: 'white' },
                        grid: { stroke: 'white' },
                        axis: { stroke: 'white' },
                    } }), (0, jsx_runtime_1.jsx)(victory_1.VictoryAxis, { orientation: "right", dependentAxis: true, tickFormat: function (x) { return (x > 0 ? "".concat(prefix).concat(x / 1000, "K") : "".concat(prefix, "0")); }, style: {
                        axis: { stroke: 'white' },
                        ticks: { stroke: 'white' },
                    }, crossAxis: false }), showChartData] })) }));
};
exports.default = SpendTrendGraph;
